import { Button } from '../../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../../components/modal/modal';
import { Select } from '../../../../../../../components/select/select';
import s from './menu-informer-copy-dish-modal.module.css';
import { useMenuInformerCopyDishModal } from './use-menu-informer-copy-dish-modal';

export const MenuInformerCopyDishModal = (props: ModalProps) => {
  const {
    categories,
    category,
    isLoading,
    handleCopy,
    section,
    sections,
    setCategory,
    handleSelectSection,
    t,
    menu,
    menus,
    handleSelectMenu,
  } = useMenuInformerCopyDishModal(props);

  return (
    <Modal {...props} className={s.feature} title={t('Копировать')}>
      <Select
        placeholder={t('Целевое меню')}
        name="menu"
        options={menus}
        value={menu}
        onSelect={handleSelectMenu}
      />
      <Select
        placeholder={t('Целевой раздел')}
        name="section"
        options={sections}
        value={section}
        onSelect={handleSelectSection}
      />
      <Select
        placeholder={t('Целевая категория')}
        name="category"
        options={categories}
        value={category}
        onSelect={setCategory}
      />
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose} disabled={isLoading}>
          {t('Отменить')}
        </Button>
        <Button onClick={handleCopy} disabled={isLoading}>
          {t('Копировать')}
        </Button>
      </div>
    </Modal>
  );
};
